RivalIQ.apps.Registration.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAdder = RivalIQ.landscape.views.CompanyAdd.extend({
        template: '#companyAdderTemplate',

        ui: {
            companySearch: '.x-search',
            domainInput: '.x-domain-input',
            companyPreview: '.x-company-preview',
            companyAddButton: '.x-company-search'
        },

        events: _.extend({}, RivalIQ.landscape.views.CompanyAdd.prototype.events, {
            'focusout @ui.domainInput': 'searchOnBlur'
        }),

        initialize: function (options) {
            const me = this;

            // NOTE: this class extends from CompanyAdd, but we're not calling its initialize as we don't
            // want all of the event listeners it adds. We should refactor that class if we're just going
            // to reuse bits and pieces of it.
            me.isFocusCompany = _.get(options, 'isFocusCompany');
            me.focusCompanyUrl = _.get(options, 'url');

            me.listenTo(me.model, 'company-add-error', me.search);

            me.listenTo(me.model, 'company-add-autocomplete', me.handleAutocomplete);

            me.listenTo(me.model, 'company-add-autocomplete-search', me.search);

            me.listenTo(me.model, 'clear-button-clicked', me.handleClearButtonClicked);
        },

        focus: function () {
            const me = this;
            me.ui.domainInput.focus();
        },

        serializeData: function () {
            const me = this;

            return _.extend(me.model.toJSON(), {
                placeholder: (me.isFocusCompany ? `Enter Your Company's URL` : `Competitor's URL`)
            });
        },

        onRender: function () {
            const me = this;

            // hookup the autocomplete
            me.typeahead = new RivalIQ.landscape.views.CompanyAddTypeahead({
                el: me.ui.domainInput,
                pubsub: me.model,
                showUserInput: true
            });

            // auto look up the focus company or default companies
            const id = me.model.get('id');
            const url = me.focusCompanyUrl;
            if (url || id) {
                me.ui.domainInput.val(url);
                me.handleAutocomplete({
                    host: url,
                    isInitialFocusCompanySearch: true
                });
            }

            if (me.isFocusCompany) {
                me.clearDisabledState();
            }

            me.ui.domainInput.keyup(me.updateAddButton.bind(me));
        },

        handleClearButtonClicked: function (e) {
            const me = this;

            e.preventDefault();

            me._clearCompany();

            me.ui.companyPreview.hide();
            me.ui.companySearch.show();

            me.ui.domainInput.val('');
            me.ui.domainInput.focus();

            me.updateAddButton();
        },

        loadData: undefined,

        updateAddButton: function () {
            const me = this;

            const domain = $.trim(me.ui.domainInput.val());

            if (domain.match(/^\S+\.\S+$/)) {
                me.ui.companyAddButton.addClass('btn-primary');
            } else {
                me.ui.companyAddButton.removeClass('btn-primary');
            }
        },

        handleAutocomplete: function (selection) {
            const me = this;

            me.isSearching = true;

            let isCompanyDataLoaded = false;
            const url = selection.host;
            const landscapeId = RivalIQ.state.landscape.id;

            me.focusNextInput();

            me.model.set({
                url: url,
                follow: false,
                landscapeId: landscapeId,
                isLoading: true
            }, {
                silent: true
            });

            // We need to separate this model from the one being used to generate company search results
            me.results = me.model.clone();

            // Hide input and show company search loading
            me.ui.companySearch.hide();
            me.ui.companyPreview.show();

            const addResultView = new RivalIQ.landscape.views.CompanyAddResults({
                template: '#recommendationViewBlank',
                pubsub: me.model,
                model: me.results,
                disableUnfollow: true,
                el: me.ui.companyPreview,
                landscapeId: landscapeId,
                enableClearButton: true,
                clearButtonText: 'Edit',
                useFadeInAnimation: true
            }).render();

            addResultView.clearWithNoLoading();

            if (!me.isFocusCompany) {
                me.ui.companyPreview.addClass('animating');
                me.ui.companyPreview.velocity('slideDown', {
                    duration: 250,
                    complete: function () {
                        me.ui.companyPreview.removeClass('animating');

                        if (!isCompanyDataLoaded) {
                            addResultView.clearAndShowLoading();
                        }
                    }
                });
            } else {
                me.ui.companyPreview.removeClass('animating');
                addResultView.clearAndShowLoading();
            }

            App.trigger('company-changed');

            me.model.save()
                .always(function () {
                    me.isSearching = false;
                    isCompanyDataLoaded = true;
                    me.model.set({
                        isLoading: false
                    }, {
                        silent: true
                    });
                    App.trigger('company-changed');
                })
                .done(function (data) {
                    me.results.set(data);
                    const isNew = RivalIQ.utils.createStatus.stillFinding(data.create_status);
                    RivalIQ.execute('tracking:push:auth', 'V3RegistrationAddedCompanyToLandscape', {
                        isNew: isNew
                    });

                    if (me.isFocusCompany) {
                        App.trigger('initial-focus-company-valid');
                    }
                })
                .fail(function (xhr) {
                    if (selection.isInitialFocusCompanySearch) {
                        // we just triggered a change, so set timeout before toggling these again
                        setTimeout(function () {
                            me.ui.companyPreview.hide();
                            me.ui.companySearch.show();
                        }, 0);
                    } else {

                        let error = {
                            RESTerror: {
                                name: 'ProblemAddingCompanyError',
                                message: 'ProblemFetchingUrlError',
                                displayString: 'ProblemAddingCompanyError'
                            }
                        };

                        try {
                            error = JSON.parse(xhr.responseText);
                        } catch (e) {
                            // do nothing;
                        }

                        me.results.set(error);
                    }

                    const input = me.ui.domainInput;
                    me.ui.companySearch.show();
                    input.val('');
                    input.focus();
                });
        },

        focusNextInput: function () {
            const me = this;

            const inputsParentSelector = me.getOption('inputsParentSelector');
            if (inputsParentSelector) {
                const inputs = me.$el.closest(inputsParentSelector).find('input');
                const myIndex = inputs.index(me.ui.domainInput);
                if (myIndex >= 0) {
                    inputs.eq(myIndex + 1).focus();
                }
            }
        },

        searchOnBlur: function () {
            const me = this;

            const domain = $.trim(me.ui.domainInput.val());

            if (domain.match(/^\S+\.\S+$/) && me.ui.domainInput.is(':visible')) {
                me.search();
            }
        },

        search: function () {
            const me = this;

            if (!me.isSearching) {
                const input = me.ui.domainInput;
                let domain = $.trim(input.val());
                domain = RivalIQ.utils.url.stripHypertextProtocol(domain);

                if (!domain || !domain.match(/\./)) {
                    me._clearCompany();

                    input.focus();
                    me.ui.companyPreview.show();
                    new RivalIQ.landscape.views.CompanyAddResults({
                        model: new Backbone.Model({
                            url: domain,
                            RESTerror: {
                                name: 'notDomain'
                            }
                        }),
                        pubsub: me.model,
                        el: me.ui.companyPreview
                    }).render();

                    return false;
                }

                // tell our typeahead we have made a selection
                if (me.typeahead) {
                    me.typeahead.selectionMade = true;
                }

                me.handleAutocomplete({
                    host: domain
                });
            }
        },

        _clearCompany: function () {
            const me = this;

            me.model.clear({
                silent: true
            });

            RivalIQ.execute('tracking:push:auth', 'V3RegistrationRemovedCompanyFromLandscape', {
                isFocusCompany: Boolean(me.isFocusCompany),
                autoFocusCompanyUrl: Boolean(me.focusCompanyUrl)
            });

            App.trigger('company-changed');
        }
    });

    views.CompaniesAdder = RivalIQ.views.CompositeView.extend({
        template: '#companiesAdderTemplate',

        childViewContainer: '.x-companies-list',

        childView: views.CompanyAdder,

        childViewOptions: {
            inputsParentSelector: '.x-competitors'
        },

        focusFirst: function () {
            const me = this;
            me.children.findByIndex(0).focus();
        }
    });
});
